import { createSlice } from "@reduxjs/toolkit";
import Api from "../api/Api";

type State = {
  data: string[];
  isLoading: boolean;
  error: Object | null;
};

const INITIAL_STATE: State = {
  data: [],
  isLoading: false,
  error: null,
};

const categoriesByBalance = createSlice({
  name: "categoriesByBalance",
  initialState: INITIAL_STATE,
  reducers: {
    fetchCategoriesByBalanceStart(state: State) {
      state.isLoading = true;
      state.error = null;
    },
    fetchCategoriesByBalanceSuccess(state: State, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchCategoriesByBalanceFailed(state: State, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.data = [];
    },
    resetCategoriesByBalance(state: State) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export default categoriesByBalance.reducer;

export const {
  fetchCategoriesByBalanceStart,
  fetchCategoriesByBalanceSuccess,
  fetchCategoriesByBalanceFailed,
  resetCategoriesByBalance,
} = categoriesByBalance.actions;

export const fetchCategoriesByBalance = (brandId: string, balance: string) => {
  return async (dispatch: any) => {
    if (!balance) {
      dispatch(resetCategoriesByBalance());
      return;
    }

    dispatch(fetchCategoriesByBalanceStart());
    try {
      const api = new Api();
      const response = await api.getCategoriesByBalance(brandId, balance);
      const categoriesData = Array.isArray(response) ? response : (response.data || []);
      dispatch(fetchCategoriesByBalanceSuccess(categoriesData));
    } catch (error) {
      console.error("Error fetching categories by balance:", error);
      dispatch(fetchCategoriesByBalanceFailed(error));
    }
  };
};
